import Container, { Service } from 'typedi';
import { Brand, MigrationState } from '../../models/enums/general-enums';
import { WindowToken } from '../../injection-tokens';

@Service()
export class MigrationUtils {
    private readonly _window: Window;
    private readonly _migrationStateId: number;
    private readonly _brandId: number;

    constructor() {
        this._window = Container.get(WindowToken);
        const migrationData =
            this._window.pageContextManager.getMigrationData &&
            this._window.pageContextManager.getMigrationData();
        this._migrationStateId = migrationData?.configuration?.stateId;
        this._brandId = this._window.pageContextManager.getBrandData()?.brandId;
    }

    public isEagleMigrationCompatible = (): boolean => {
        return (
            this._migrationStateId &&
            this._migrationStateId >= MigrationState.EagleMigrationStateId &&
            this._brandId == Brand.Sport_RO
        );
    };
}
